import { v4 as uuidv4 } from "uuid";
import { ReactElement } from "react";
import { SearchResultData } from "../../app/slices/SearchResultsSlice";
import { InteractionFactoryEntity } from "../../features/interaction_factory/InteractionFactory";
import CloseCustomQuizNodePreview from "../../features/sequence/node_previews/CloseCustomQuizNodePreview";
import { Actor } from "../Actor";
import Take from "../Take";
import Interaction, { InteractionType } from "./Interaction";

export interface ICloseCustomQuiz extends Interaction {}

export const closeCustomQuizInteraction = (): InteractionFactoryEntity => {
  const view: ReactElement = <></>;

  const create = (getKeys: (amount: number) => string[]): ICloseCustomQuiz => {
    return {
      id: uuidv4(),
      name: "Close Custom Quiz",
      type: InteractionType.CloseCustomQuiz,
      properties: [],
    };
  };

  const migrate = (
    from: number,
    to: number,
    interaction: Interaction,
  ): ICloseCustomQuiz => {
    return interaction as ICloseCustomQuiz;
  };

  const copy = (
    interaction: Interaction,
    getKeys: (amount: number) => string[],
    replaceKey: (from: string, to: string) => void,
  ): ICloseCustomQuiz => {
    return create(getKeys);
  };

  const validate = (
    interaction: Interaction,
    getValue: (key: string) => string,
    currentTake: Take,
    actorPresets: Actor[],
  ): string[] => {
    const warnings: string[] = [];
    return warnings;
  };

  const validateErrors = (): string[] => {
    return [];
  };

  const filter = (
    interaction: Interaction,
    takeName: string,
    getMatchingResults: (
      searchableStrings: string[],
      takeName: string,
      interaction: Interaction,
      filterType: string,
    ) => SearchResultData[],
    getValue: (key: string) => string,
  ): SearchResultData[] => {
    const searchableStrings: string[] = [interaction.name];

    return getMatchingResults(
      searchableStrings,
      takeName,
      interaction,
      filterType,
    );
  };

  const filterType: string = "Close Custom Quiz";

  return {
    View: view,
    NodeView: (nodeId: string, interaction: Interaction) => (
      <CloseCustomQuizNodePreview nodeId={nodeId} interaction={interaction} />
    ),
    FilterType: filterType,
    Create: create,
    Migrate: migrate,
    Copy: copy,
    Validate: validate,
    Filter: filter,
    ValidateErrors: validateErrors,
  };
};
